import React from 'react';
import { useBreakpointValue } from '@spothero/ui';
import useConfig from './use-config';
export const isMobilePortraitView = () => {
    const mobileXL = '30rem';
    if (typeof window === 'undefined') {
        return false;
    }
    return window.matchMedia(`(max-width: ${mobileXL})`).matches || false;
};
// Tablet used as default due to not wanting full search for tablet
// This is modeled off the consumer-checkout setup and eliminates hydration issues
const useIsMobile = (breakpointValue = 'tablet') => {
    const { isMobile } = useConfig();
    return useBreakpointValue({ base: true, [breakpointValue]: false }, isMobile ? 'base' : breakpointValue);
};
export function withIsMobile(Component) {
    const WithIsMobile = (props = {}) => {
        const isMobile = useIsMobile();
        return <Component {...props} isMobile={isMobile}/>;
    };
    WithIsMobile.displayName = `WithIsMobile(${Component.displayName || Component.name || 'Component'})`;
    return WithIsMobile;
}
export default useIsMobile;
